import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { settlementNdsTypeIds, settlementNdsTypeMatches } from "helpers/mutualSettlements";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import React from "react";

/** Shared backend VAT label for receivable/payable leaves; group headers have no single rate. */
const vatColumn = {
    Header: "Ставка НДС",
    accessor: "nds",
    Cell: ({ value, row }) => !row.isGrouped && <div className="text-center">{value ?? ""}</div>,
    filterable: true,
    filter: (rows, _id, filterValue) => {
        const selected = settlementNdsTypeIds(filterValue?.value);
        return selected.length
            ? rows.filter((row) => settlementNdsTypeMatches(row.original.ndsTypeId, selected))
            : rows;
    },
    Filter: reportFilterWrapper((props) => (
        <SelectColumnFilter
            {...props}
            selectProps={{
                ...defaultMultipleSelectProps,
                dictionary: "nDSType",
                options: props.column.options || [],
                inputProps: { name: "ndsTypeId" },
                components: { ValueContainer },
            }}
        />
    )),
};

export default vatColumn;
